// eslint-disable-next-line import/no-cycle
import { postApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({}),
	mutations: {},
	actions: {
		async requestCall() {
			const response = await postApi('/k5/v1/user/support-call');
			return response;
		},
	},
};
